import { render, staticRenderFns } from "./calculated-details.vue?vue&type=template&id=502d3b7d&scoped=true"
import script from "./calculated-details.vue?vue&type=script&lang=ts"
export * from "./calculated-details.vue?vue&type=script&lang=ts"
import style0 from "./calculated-details.vue?vue&type=style&index=0&id=502d3b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d3b7d",
  null
  
)

export default component.exports